import { isBeekeeperIntegrationEnabled } from '@lumapps/beekeeper/ducks/selectors';
import { isBeekeeperFeatureEnabled, isFeatureEnabled } from '@lumapps/features';
import { createSelector } from '@lumapps/redux/reselect';

import { BEEKEEPER_CHAT, BEEKEEPER_CHAT_BACKEND, BEEKEEPER_CHATS, SMART_GROUP_CHATS_MANAGEMENT } from '../constants';

export const isBeekeeperChatEnabled = isBeekeeperFeatureEnabled(BEEKEEPER_CHAT);
export const isBeekeeperChatBackendEnabled = isBeekeeperFeatureEnabled(BEEKEEPER_CHAT_BACKEND);
export const isChatsEnabledFF = isFeatureEnabled(BEEKEEPER_CHATS);

export const isChatsEnabled = createSelector(
    isChatsEnabledFF,
    isBeekeeperIntegrationEnabled,
    isBeekeeperChatEnabled,
    isBeekeeperChatBackendEnabled,
    (isChatsFFEnabled, isIntegrationEnabled, isBkprChatEnabled, isBkprChatBackendEnabled) =>
        isChatsFFEnabled && isIntegrationEnabled && isBkprChatEnabled && isBkprChatBackendEnabled,
);

export const isSmartGroupChatsManagementEnabled = createSelector(
    isChatsEnabled,
    isBeekeeperFeatureEnabled(SMART_GROUP_CHATS_MANAGEMENT),
    (chatsEnabled, smartGroupManagementEnabled) => chatsEnabled && smartGroupManagementEnabled,
);
